import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './App.css';
import Header from './components/Header';
import Navigation from './components/Navigation';
import DataPage from './pages/DataPage';
import AudioPage from './pages/AudioPage';
import AssetsPage from './pages/AssetsPage';
import DocsPage from './pages/DocsPage';
import ExamplePage from './pages/ExamplePage';
import ExamplesHomePage from './pages/ExamplesHomePage';
import AIInstructionsPage from './pages/AIInstructionsPage';
import DonatePage from './pages/DonatePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Provider store={store}>
      <Router basename="/">
        <div className="App">
          <div id="container" className="container">
            <Header />
            <Navigation />
            <Routes>
              <Route path="/" element={<DocsPage />} />
              <Route path="/data" element={<DataPage />} />
              <Route path="/audio" element={<AudioPage />} />
              <Route path="/assets" element={<AssetsPage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/examples" element={<ExamplesHomePage />} />
              <Route path="/examples/:exampleName" element={<ExamplePage />} />
              <Route path="/ai-instructions" element={<AIInstructionsPage />} />
            </Routes>
          </div>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
